import {ReactNode} from "react";

import {Text} from "@pg-design/text-module";

import {PROPERTY_CARD_DETAIL_MAP_CONTENT} from "../../constants/property_card_detail_map_content";

import * as styles from "./HomematchPropertyCardDetailMap.module.css";

interface IProps {
    /** The actual map implementation — apps inject their own; null renders the load-error state. */
    map: ReactNode | null;
}

export const HomematchPropertyCardDetailMap = (props: IProps) => {
    const {map} = props;

    return (
        <section className={styles.section}>
            <Text className={styles.miniHeader} color="var(--colors-secondary)" variant="mini_header">
                {PROPERTY_CARD_DETAIL_MAP_CONTENT.TITLE}
            </Text>

            {map ?? (
                <div className={styles.mapErrorHolder}>
                    <Text>{PROPERTY_CARD_DETAIL_MAP_CONTENT.LOAD_ERROR}</Text>
                </div>
            )}
        </section>
    );
};
import {ReactNode} from "react";

import {Text} from "@pg-design/text-module";

import {PROPERTY_CARD_DETAIL_MAP_CONTENT} from "../../constants/property_card_detail_map_content";

import * as styles from "./HomematchPropertyCardDetailMap.module.css";

interface IProps {
    /** The actual map implementation — apps inject their own; null renders the load-error state. */
    map: ReactNode | null;
}

export const HomematchPropertyCardDetailMap = (props: IProps) => {
    const {map} = props;

    return (
        <section className={styles.section}>
            <Text className={styles.miniHeader} color="var(--colors-secondary)" variant="mini_header">
                {PROPERTY_CARD_DETAIL_MAP_CONTENT.TITLE}
            </Text>

            {map ?? (
                <div className={styles.mapErrorHolder}>
                    <Text>{PROPERTY_CARD_DETAIL_MAP_CONTENT.LOAD_ERROR}</Text>
                </div>
            )}
        </section>
    );
};
